import React, { useState } from 'react';
import { useTranslation } from 'react-i18next'; // DÜZELTME 1: Eksik olan i18next import'u

const API_URL = process.env.REACT_APP_API_URL;

const ForgotPasswordPage = () => {
    const { t } = useTranslation(); // DÜZELTME 2: t fonksiyonunu tanımla
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false); // DÜZELTME 3: Yüklenme durumu için state

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setMessage('');
        setLoading(true);

        try {
            const response = await fetch(`${API_URL}/api/auth/forgot-password`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email })
            });
            const data = await response.json();
            
            // Backend'den hata gelse bile, kullanıcıya her zaman başarılı mesajı gösteriyoruz.
            // Bu, e-posta adreslerinin sistemde kayıtlı olup olmadığının
            // dışarıdan anlaşılmasını engelleyen bir güvenlik önlemidir.
            if (!response.ok) {
                // Hata olsa bile konsola loglayıp devam et, kullanıcıya gösterme
                console.error('Forgot password internal error:', data.messageKey || 'Unknown error');
            }
            
            // Her durumda başarılı mesajını ayarla
            setMessage(t('success_password_reset_link_sent'));

        } catch (err) {
            // Ağ hatası gibi beklenmedik bir durumda bile kullanıcıya başarılı mesajı göster
            console.error("Ağ hatası veya beklenmedik bir sorun oluştu:", err);
            setMessage(t('success_password_reset_link_sent'));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-page-container">
            <div className="auth-form-card">
                <h2>{t('forgot_password_title')}</h2>
                
                {/* Başarı mesajı varsa formu gizle */}
                {!message ? (
                    <form onSubmit={handleSubmit}>
                        <p className="auth-prompt">{t('forgot_password_prompt')}</p>
                        <div className="form-group-auth">
                            <label htmlFor="email">{t('email_address')}</label>
                            <input 
                                type="email" 
                                id="email"
                                value={email} 
                                onChange={e => setEmail(e.target.value)} 
                                required 
                             
                            />
                        </div>
                        
                        {/* Hata mesajları bu formda genellikle gösterilmez, ama bir ihtimale karşı ekleyelim */}
                        {error && <p className="auth-error">{error}</p>}

                        <button type="submit" disabled={loading}>
                            {loading ? t('loading') + '...' : t('send_reset_link_btn')}
                        </button>
                    </form>
                ) : (
                    <p className="auth-success">{message}</p>
                )}
            </div>
        </div>
    );
};

export default ForgotPasswordPage;